export default {
  // 测试
  // baseUrl: 'http://192.168.5.201:8085/',
  // downloadUrl: 'http://192.168.5.201:8080/'

  // 生产
  baseUrl: 'http://117.74.136.106:18085/',
  downloadUrl: 'http://117.74.136.106:11137/'
}
